import React, { useState } from "react";
import { Box } from "../../assets/ui";
import {
  StyledContactForm,
  StyledContactFormWrapper,
  StyledContactMap,
  StyledContactsContent,
  StyledSectionContent,
  StyledSectionWrapper
} from "./ui";
import Loader from "../../components/Modals/loader-modal";
import SimpleModal from "../../components/Modals/simple-modal";
import ThanksModal from "../../components/Modals/thanks-modal";
import { connectRequest } from "../../api";

const defaultFormData = { name: "", email: "", message: "" };
const Contact = () => {
  const [showLoader, setShowLoader] = useState(false);
  const [showThanksModal, setShowThanksModal] = useState(false);
  const [formData, setFormData] = useState({ ...defaultFormData });

  const submitHandler = async e => {
    e.preventDefault();
    setShowLoader(true);
    const data = await connectRequest("mailService/mails/connect", formData);

    if (data) {
      setShowLoader(false);
      setShowThanksModal(true);
      setFormData({ ...defaultFormData });
    } else {
      setShowLoader(false);
    }
  };

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <StyledSectionWrapper>
      <Loader isLoading={showLoader} />
      <SimpleModal
        open={showThanksModal}
        hideModal={() => setShowThanksModal(false)}
      >
        <ThanksModal closeModal={() => setShowThanksModal(false)} />
      </SimpleModal>
      <StyledSectionContent>
        <StyledContactFormWrapper>
          <h2 id="post-container">Say hello!</h2>
          <StyledContactForm id="contact_us" onSubmit={submitHandler}>
            <input
              type="text"
              placeholder="Your name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              placeholder="Your email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <textarea
              placeholder="Message in free form"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            <button type="submit">SEND</button>
          </StyledContactForm>
        </StyledContactFormWrapper>

        <StyledContactMap>
          <img src="./images/map.png" alt="" />
          <h3>Contacts</h3>

          <StyledContactsContent>
            <Box marginBottom={["32px"]} width={["50%", null, null, "33%"]}>
              <h5>Address</h5>
              <p>3 Habarzel Street Tel Aviv Israel</p>
            </Box>
            <Box
              marginBottom={["32px"]}
              width={["50%", null, null, "33%"]}
              paddingLeft={["10px"]}
            >
              <h5>Email</h5>
              <p>info@exsportia.com</p>
            </Box>
            <Box marginBottom={["32px"]} width={["50%", null, null, "33%"]}>
              <h5>Phone</h5>
              <p>+44 (0) 203 290 1106</p>
            </Box>
          </StyledContactsContent>
        </StyledContactMap>
      </StyledSectionContent>
    </StyledSectionWrapper>
  );
};

export default Contact;
